import React, { useState } from 'react'
import { Card, Button, Row, Col, Modal } from 'react-bootstrap';
import imageService from '../../service/ImageServie';
import { useNavigate } from 'react-router-dom';

function CustomerAdCard({ advertisement }) {
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const formatPhoneNumber = (phoneNumber) => {
        // Format phone number as (XXX) XXX-XXXX
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    };

    const navigate = useNavigate();

    const handleViewLeads = (adId) => {
        navigate(`/leads/${adId}`);
    };


    return (<>
        <Card className="mb-2 internal_ads_row col-md-11 p-md-1 p-0">
            <Row className='mx-0 justify-content-center'>
                <Col md={advertisement.imageName ? 9 : 12}>
                    <Card.Body className='p-0 planCard-style text-left h-100 position-relative py-1'>
                        <Row>
                            <Col md={12} className='planInfo-style'>
                            <div className='row'>
                                <div className='col-md-12 px-md-2'>
                                <div className='row justify-content-between align-items-center'>
                                    <div className='cardText col-md-5 col-lg-6 col-12'>
                                        <Card.Title title={advertisement.companyName}>
                                        {advertisement.companyName}
                                        </Card.Title>
                                    </div>
                                    <div className='cardText col-md-5 col-lg-4 col-8'>
                                       <h6 className='ad_worktype'>Work Type : <b>{advertisement.shopType}</b></h6>
                                    </div>
                                    <div className='cardText col-md-2 col-4 text-right'>
                                       <span className='ad_miles mb-0'>{advertisement.viewCount} views</span>
                                    </div>
                                </div>
                                </div>

                                <div className='col-md-12 px-md-2'>
                                 <div className='cardText'>
                                    <p className='ad_address mb-0' title={advertisement.address || `${advertisement.city}, ${advertisement.state}`}>
                                    <i className="fas fa-location-dot" title="location"></i>
                                    {advertisement.address || `${advertisement.city}, ${advertisement.state}`}
                                    </p>
                                 </div>
                                </div>

                                <div className='col-md-12 px-md-2'>
                                    <div className='cardText d-md-flex gap-3'>
                                    <p className='ad_email mb-0'><i className="fa fa-envelope" title="email"></i> {advertisement.email || 'Not Available'}</p>
                                    <p className='ad_website mb-0'><i className="fa fa-globe" title="website"></i>
                                        <a href={advertisement.website} rel="noopener noreferrer"> {advertisement.website || 'Not Available'}</a>
                                    </p>

                                    {/* {advertisement.website && (
                                            <p className='ad_website mb-2'>
                                             <i className="fa fa-globe" title="website"></i>
                                             <a href={advertisement.website} target="_blank" rel="noopener noreferrer">
                                             {advertisement.website.replace(/https?:\/\/|www\.|\/+/g, ' ')}
                                            </a>
                                        </p>
                                    )} */}

                                    </div>
                                </div>

                                <div className='col-md-12 px-md-2'>
                                    <div className='ad_services mt-md-0 mt-0'>
                                    <ul className='ad_serviceList'>
                                        {advertisement.services.slice(0, 4).map((service, index) => (
                                        <li key={index}>{service}</li>
                                        ))}
                                    </ul>
                                    </div>

                                    <div className="ad_description">
                                     <p className='mb-0'>{advertisement.description}</p>
                                    </div>
                                </div>
                            </div>

                             {advertisement.planId === 3 && (
                                <div className='row'>
                                    <div className='col-md-12 px-2'>
                                    <div className='ad_special_offer inter_ad_special'>
                                        <div className='highlight_text'>
                                        <h3>Features</h3>
                                        </div>
                                        <div className='special_offer_content'>
                                        <ul>
                                        {advertisement.highlight.split(',').map((highlight, index) => (
                                        <li key={index}>{highlight.trim() || 'Contact Us For Special Deals & Discounts....'}</li>
                                        ))}
                                        </ul>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                )}
                            </Col>
                        </Row>

                        <div className='row align-items-center mt-1'>
                           <div className='new-ad-bottom col-md-6 px-2'>
                            <div className='d-md-flex gap-md-2 gap-lg-3 align-items-center'>
                             <div className='bd_plan_contact'>
                             <button className='btn mb-0' type="button">
                             <i className="fa fa-phone" title="phone"></i> {formatPhoneNumber(advertisement.phone)}
                             </button>
                             </div>

                             <div className='ad_services'>
                             <h6 className='ad_hours'><i className="far fa-clock" title="time"></i> {advertisement.workingHours}</h6>
                             </div>
                             </div>
                            </div>

                            <div className='col-md-6 px-md-2 px-0'>
                             <div className='d-md-flex gap-md-2 gap-lg-3 align-items-center justify-content-end'>

                             <div className='new_view planPrice-style text-right px-2 px-md-0'>
                              <Button className='planBtn' variant="primary" onClick={() => handleViewLeads(advertisement.id)}>
                              {/* <i className="fas fa-user-check me-1" title="leads"></i>*/} Leads
                              </Button>
                             </div>

                             <div className='new_view planPrice-style text-right px-2 px-md-0'>
                             <Button className='planBtn' variant="primary" onClick={handleShow}>
                             {/* <i className="far fa-eye me-1" title="view"></i> */} View More
                             </Button>
                             </div>

                             </div>
                            </div>
                        </div>
                    </Card.Body>
                </Col>
                {advertisement.imageName && (
                    <Col md={3} className='p-0 align-content-around ad_banner rounded'>
                     <Card.Img className='rounded' variant="top"
                     src={`${imageService.getAdsImage}${advertisement.imageName}`}
                     alt={advertisement.companyName}
                     />
                    </Col>
                )}
            </Row>
        </Card>

        <Modal show={showModal} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton className='px-md-4 px-3'>
                <Modal.Title style={{lineHeight:'25px', fontSize:'19px'}}><strong>{advertisement.companyName}</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-md-4 p-3'>
                <p className='mb-1' style={{fontSize:'15px'}}><strong>Reference ID:</strong> #{advertisement.id}</p>
                <p className='mb-1' style={{fontSize:'15px'}}><strong>Address:</strong> {`${advertisement.address}, ${advertisement.city}, ${advertisement.state}, ${advertisement.country}`}</p>
                <p className='mb-1' style={{fontSize:'15px'}}><strong>Phone:</strong> {advertisement.phone || 'Not available'}</p>
                <p className='mb-1' style={{fontSize:'15px'}}><strong>Email:</strong> {advertisement.email || 'Not available'}</p>
                <p className='mb-1' style={{fontSize:'15px'}}><strong>Website:</strong> {advertisement.website || 'Not available'}</p>
                <p className='mb-1' style={{fontSize:'15px'}}><strong>Working Hours:</strong> {advertisement.workingHours}</p>
                <p className='mb-1' style={{fontSize:'15px'}}><strong>Shop Type:</strong> {advertisement.shopType}</p>
                <p className='mb-0' style={{fontSize:'15px'}}><strong>Description:</strong> {advertisement.description}</p>
                <div>
                 <strong style={{fontSize:'15px'}}>Services:</strong>
                 <ul className='px-3 mb-0'>
                  {advertisement.services.map((service, i) => (
                  <li key={i} style={{fontSize:'15px'}}>{service}</li>
                  ))}
                 </ul>
                </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    </>

    );
}

export default CustomerAdCard